// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

export const StoneGradeFragmentDoc = `
    fragment stoneGrade on StoneGrade {
  systemCode
  translation(locale: $locale) {
    name
  }
}
    `;